import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from 'src/app/core/services/rest.service';
import { ApiResult } from 'src/app/core/models/api-result.model';

export interface IcalToken {
  token: string | null;
  url: string | null;
}

@Injectable({ providedIn: 'root' })
export class IcalTokenService {
  constructor(private rs: RestService) {}

  get(): Observable<IcalToken> {
    return this.rs.get_api('alerts/ical-token').pipe(map(this.toToken));
  }

  generate(): Observable<IcalToken> {
    return this.rs.post_api('alerts/ical-token/generate', {}).pipe(map(this.toToken));
  }

  regenerate(): Observable<IcalToken> {
    return this.rs.post_api('alerts/ical-token/regenerate', {}).pipe(map(this.toToken));
  }

  private toToken(res: ApiResult): IcalToken {
    if (res?.success && res.result) {
      return { token: res.result.token ?? null, url: res.result.url ?? null };
    }
    return { token: null, url: null };
  }
}
